<template>
  <div class="list">
    <div class="breadcrumb">
      <div class="breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item>老师管理</Breadcrumb-item>
          <Breadcrumb-item>老师合同</Breadcrumb-item>
        </Breadcrumb>
      </div>
    </div>
    <Row>
      <Col :span="4">
        <Select v-model="formData.contractVersionId" @on-change="onChange">
          <Option v-for="item in formData.versionList" :value="item.id" :key="item.id">{{ item.title}}</Option>
        </Select>
      </Col>
      <Col :span="4">
        <Select v-model="formData.enabled" placeholder="请选择">
          <Option :value="1">启用</Option>
          <Option :value="0">禁用</Option>
        </Select>
      </Col>
    </Row>
   <Row>
     <quillEditor v-model="formData.contract" ref="myQuillEditor" :options="editorOption"
                  @change="textChange"></quillEditor>
   </Row>
    <div slot="footer" :style="{ marginTop: '10px' }">
      <Button type="text" size="large" @click="onBack">取消</Button>
      <Button type="primary" size="large" @click="openPreview" :style="{ marginLeft: '10px', marginRight: '10px'}">预览</Button>
      <Button type="primary" size="large" :loading="loadingInsert" @click="saveData">保存</Button>
    </div>
  </div>
</template>
<script>
import * as Quill from 'quill'
import {quillEditor} from 'vue-quill-editor'

var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif']
var Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  components: {
    quillEditor,
  },
  name: 'TchContract',
  data () {
    return {
      loadingInsert: false,
      reload: 0,
      currentVersionId: '',
      currentContract: '',
      formData: {
        id: '',
        tchId: '',
        contract: '',
        contractVersionId: '',
        enabled: '',
        confirmed: '',
        confirmTime: '',
        versionList: [],
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{'header': 1}, {'header': 2}],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'indent': '-1'}, {'indent': '+1'}],
              [{'size': ['small', false, 'large', 'huge']}],
              [{'header': [1, 2, 3, 4, 5, 6, false]}],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              [{'font': fonts}],
              ['clean'],
              ['link', 'image', 'video']
            ],
          },
        }
      }
    }
  },
  mounted: function () {
    let self = this
    self.formData.tchId = this.$route.query.tchId
    if (self.formData.tchId === undefined) {
      this.$router.go(-1)
      return
    }
    self.$http.get('/tch/lesson/contract?tchId=' + self.formData.tchId).then(function (res) {
      if (res.data.tchId) {
        self.currentVersionId = res.data.contractVersionId
        self.currentContract = res.data.contract
        self.formData = res.data
      } else {
        self.formData.versionList = res.data.versionList
      }
    })
  },
  created: function () {
  },
  methods: {
    onChange (val) {
      this.formData.versionList.forEach(v => {
        if (v.id === val && this.currentVersionId !== v.id) {
          this.formData.contract = v.contract
        } else if (v.id === val && this.currentVersionId === v.id) {
          this.formData.contract = this.currentContract
        }
      })
    },
    onBack () {
      this.backToPreviousPage()
    },
    openPreview () {
      // 获取合同内容
      let contract = this.$refs.myQuillEditor.quill.root.innerHTML

      // 添加样式：标题为三号字体(16pt)，内容为四号字体(14pt)，并移除打印预览时的文字栏
      const styleTag = `<style>
        /* 移除打印预览时的文字栏并调整页面边距 */
        @media print {
          @page { margin: 0 1.6cm 0 1.6cm; } /* 为每一页设置顶部边距3厘米 */
          body { margin: 0; } /* 重置body边距，使用@page的边距控制 */
          .button { display: none !important; border: none; }
        }
      </style>`

      // 将样式添加到合同内容中
      contract = styleTag + contract

      let url = `https://test-h5.kouyujie.cn/contract/preview.html`
      if (this.$appConfig.active === 'prod') {
        url = `https://h5.speakstreet.cn/contract/preview.html`
      }
      const newWindow = window.open(url, '_blank')
      setTimeout(() => {
        newWindow.postMessage({type: 'SET_CONTENT', contract}, '*')
      }, 1000)
    },
    textChange (val) {

    },
    saveData () {
      let self = this
      self.loadingInsert = true
      self.$http.post('/tch/lesson/edit-contract', self.formData).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('保存成功!')
          self.backToPreviousPage()
        }
        self.loadingInsert = false
      }).catch(function (e) {
        self.loadingInsert = false
      })
    },
    backToPreviousPage () {
      const from = decodeURIComponent(this.$route.query.from || '/')
      this.$router.push(from)
    }
  },
}
</script>



// WEBPACK FOOTER //
// TchContract.vue?b2363822